// src/icons/TwitterIcon.js
import React from 'react';

const TwitterIcon = ({ size = 24, color = "currentColor" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill={color}
    >
        <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.33 4.33 0 001.88-2.39 8.67 8.67 0 01-2.73 1.05A4.32 4.32 0 0016.02 4c-2.4 0-4.35 1.95-4.35 4.35 0 .34.04.67.11.98-3.6-.18-6.79-1.9-8.92-4.52a4.35 4.35 0 00-.59 2.19c0 1.5.76 2.83 1.92 3.61a4.3 4.3 0 01-1.97-.54v.05c0 2.1 1.49 3.85 3.47 4.24a4.35 4.35 0 01-1.97.08 4.33 4.33 0 004.04 3A8.68 8.68 0 012 20.29a12.22 12.22 0 006.6 1.93c7.92 0 12.25-6.56 12.25-12.25 0-.18 0-.36-.01-.54A8.76 8.76 0 0024 5.4a8.62 8.62 0 01-2.54.7A4.3 4.3 0 0022.46 6z" />
    </svg>
);

export default TwitterIcon;
